import React, { useEffect, useState } from 'react';
import TableDataLayer from "../components/TableDataLayer";
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, NavLink } from 'react-router-dom';
import { apiCall } from "../utils/apiService";

const PaymentLayer = () => {
    const [data, setData] = useState([]);
    const [copySuccess, setCopySuccess] = useState("Copy");

    const fetchPayments = async () => {
        try {
            const response = await apiCall({
                url: `payments/get-all`,
                method: 'GET',
            });
            setData(response.total);
            return response
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const removePayment = async (id) => {
        try {
            const response = await apiCall({
                url: `sessions/delete/${id}`,
                method: 'DELETE',
            });
            if (response.success) {
                setData(data - 1);
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const removeMessageLog = async (selected, type = null) => {
        try {
            const response = await apiCall({
                url: `user/del-logs`,
                method: 'POST',
                body: { selected: selected, type: type }
            });
            if (response.success) {
                setData(data - 1);
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const handleCopy = async (id) => {
        try {
            await navigator.clipboard.writeText(id);
            setCopySuccess("Copied to clipboard!");
            setTimeout(() => {
                setCopySuccess("Copy");
            }, 2000);
        } catch (err) {
            setCopySuccess("Failed to copy!");
            console.error("Failed to copy text:", err);
        }
    };

    const columns = [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        {
            key: 'status',
            label: 'Status',
            render: (row) => (
                <span className={`badge bg-${row.active == 1 ? 'success' : 'danger'}`}>
                    {row.active == 1 ? 'Paid' : 'UnPaid'}
                </span>
            ),
        },
        { key: 'delay', label: 'Delay' },
        {
            key: 'createdAt',
            label: 'Created At',
            render: (val, row) => {
                const date = new Date(row.createdAt);
                return date.toLocaleString();
            },
        },
        {
            key: 'actions',
            label: 'Actions',
            render: (val, row) => (
                <>
                    <button
                        to="#"
                        title={copySuccess}
                        onClick={() => handleCopy(row.client_id)}
                        as={NavLink}
                        className="w-32-px h-32-px me-8 bg-success-light text-success-600 rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="iconamoon:copy-light" />
                    </button>
                    <button
                        onClick={() => removeMessageLog(row.client_id, 'Payment')}
                        title="Delete Logs"
                        className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="lucide:x" />
                    </button>
                    <button
                        onClick={() => removePayment(row.client_id)}
                        title="Delete Payment"
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                    >
                        <Icon icon="mingcute:delete-2-line" />
                    </button>
                </>

            ),
        },
    ];

    useEffect(() => {
        document.title = 'Payment List'
        // fetchPayments();
    }, [])

    return (
        <>
            {/* TableDataLayer */}
            <div className="card basic-data-table">
                <div className="card-header">
                    <div className="d-flex justify-content-between alig-items-center">
                        <h5 className="card-title mb-0">Payment List</h5>
                        <div>
                            <Link to="/scan-qrcode" className="btn btn-success"><Icon
                                icon="ic:baseline-plus"
                                className="icon text-xl line-height-1"
                            /> Add Payment</Link>
                        </div>
                    </div>
                </div>
                <TableDataLayer
                    columns={columns}
                    totalRows={data}
                    fetchData={fetchPayments}
                />
            </div>
        </>
    );
}

export default PaymentLayer